import { ImsObject } from './ims_object';
import { RadioResource } from 'app/shared/resources';
import * as _ from 'lodash';

export const IMS_TYPE__RADIO = 'radio';

// The mapping of the displayed name for the mac field in radio to the radio's type

export class Radio extends ImsObject {
    private _labelName: string = null;

    constructor(resource = new RadioResource()) {
        super(IMS_TYPE__RADIO, resource);
    }

    get name() {
        return this.resource.name;
    }

    set name(name) {
        this.resource.name = name;
    }

    get labelName() {
        return this._labelName ? this._labelName : this.name;
    }

    set labelName(value: string) {
        this._labelName = value;
    }

    get mac() {
        return this.resource.mac;
    }

    set mac(mac) {
        this.resource.mac = mac;
    }

    get network_id_type() {
        return this.resource.network_id_type;
    }

    set network_id_type(network_id_type) {
        this.resource.network_id_type = network_id_type;
    }

    get type() {
        return this.resource.type;
    }

    set type(type) {
        this.resource.type = type;
    }

    get ipDeviceId() {
        return this.resource.ip_device_id;
    }

    set ipDeviceId(newIpDeviceId) {
        this.resource.ip_device_id = newIpDeviceId;
    }

    get technologyId() {
        return this.resource.technology_id;
    }

    set technologyId(newTechnologyId) {
        this.resource.technology_id = newTechnologyId;
    }

    get isDeleted() {
        return this.resource.is_deleted;
    }

    set isDeleted(isDeleted) {
        this.resource.is_deleted = isDeleted;
    }

    clone() {
        const resourceClone = _.clone(this.resource);

        const result = new Radio(resourceClone);
        result.type = this.type;
        result.name = this.name;
        return result;
    }

    diff(radio) {
        if (radio.constructor === Radio) {
            return ['id', 'ipDeviceId', 'mac', 'name', 'type'].filter((key) => {
                return radio[key] !== this[key];
            });
        } else {
            throw new Error('Can only diff with a Radio');
        }
    }

    /**
     * Some weak validation for a radio.
     * We rely on the radio body component to do validation of strings,
     * i.e. is it a valid mac address.
     *
     * In the future we may consider moving the validation out of the component
     * to here if we need this validation to be stronger.
     *
     * @param {Radio} radio
     * @returns {boolean} True if valid
     */
    static isValid(radio: Radio): boolean {
        if (!radio.type || !radio.name || !radio.mac) {
            return false;
        }
        return true;
    }

    static toFilterable(radio: Radio): object {
        return {
            name: radio.name,
            mac: radio.mac,
            type: radio.type,
        };
    }
}
